function seededRandom(seed: number) {
  let v = seed;
  return () => {
    v = (v * 9301 + 49297) % 233280;
    return v / 233280;
  };
}

type Star = {
  left: number;
  top: number;
  size: number;
  delay: number;
  duration: number;
};

export function CssStarfield({
  seed = 1,
  count = 90,
  color = "var(--color-primary-light)",
  className = "absolute inset-0",
}: {
  seed?: number;
  count?: number;
  color?: string;
  className?: string;
}) {
  const rand = seededRandom(seed);
  const stars: Star[] = Array.from({ length: count }, () => ({
    left: rand() * 100,
    top: rand() * 100,
    size: 1 + rand() * 1.8,
    delay: rand() * 6,
    duration: 3 + rand() * 4,
  }));

  return (
    <div
      aria-hidden
      className={`pointer-events-none overflow-hidden ${className}`}
      style={{ contain: "strict", contentVisibility: "auto" }}
    >
      {stars.map((s, i) => (
        <span
          key={i}
          className="absolute rounded-full motion-safe:[animation-name:starTwinkle] motion-safe:[animation-timing-function:ease-in-out] motion-safe:[animation-iteration-count:infinite]"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            backgroundColor: color,
            opacity: 0.5,
            animationDuration: `${s.duration}s`,
            animationDelay: `${s.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
